import Input from "./Input";

export * from ".";
export default Input;